const gpEventKey = {
  gameName: 'game-name',
  gameCode: 'game-code',
  favorite: 'favorite',
  layout: 'layout-name',
  gameOrientation: 'game-orientation',
  loadTime: 'load-time',
  category: 'category-name',
} as const

export {gpEventKey}
